<!-- <p>ledger-record works!</p> -->
<!-- Card -->
<div class="mainCard" style="border-radius: 3px;box-shadow: 0 5px 8px rgb(0 0 0 / 20%);">
  <!-- Card Header -->
  <div class="mainCardHeader">
    <div style="display: inline-block; width: 50%; text-align: left; font-weight: 600;">
      <div style="font-size: 20px;">
        Ledger Record
      </div>
    </div>
    <div style="display: inline-block; width: 50%; text-align: right; vertical-align: top; line-height: 40px;">

      <!-- <i class="fa fa-pencil" (click)="openEditGroupModal(editGroup,ledgernData)" aria-hidden="true" style="cursor: pointer;"></i>
     
      <i class="fa fa-trash-o"  (click)="deleteLedger(ledger.id)" style="cursor: pointer; margin-left: 15px;color:gray;" aria-hidden="true"></i> -->

      <input type="text" *ngIf="isShowSearch" [(ngModel)]="search" class="form-control width50"
        style="display: inline-block;font-size: 13px;" autofocus />
      <span *ngIf="voucher.length > 0" style="margin-left: 10px;" class="searchBtn brdrRadius3" (click)="showSearch()" title="Search">
        <i class="fa fa-search headerIcon" aria-hidden="true"></i>
      </span>

      <a class="expandBtn brdrRadius3" (click)="expandView()" target="{{isWeb ? '_blank' : '_self'}}" title="Expand">
        <i class="fa fa-expand headerIcon webView" aria-hidden="true"></i>
      </a>

      <i class="fa fa-filter headerIcon" aria-hidden="true"
        style="margin-right: 0px; color:#795548 !important; display: none;"></i>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12" style="font-weight: normal; color: #1F628E; padding: 0px;">

      <div class="col-md-6 col-sm-6 col-xs-8" style="display: inline-block;padding: 0px !important; width: calc(80% - 42px) !important;">
        <input class="form-control bzInput" placeholder="Select Ledger" list="ledgers" [(ngModel)]="ledgername" matInput style="width: 100%; padding: 3px 8px;
        font-family: inherit;color: #555; font-size: 13px;" (blur)="filterLedgerChange(ledgername)">
        <datalist id="ledgers" class="font13">
          <option *ngFor="let L of ledgers" [value]="L.LedgerName"> {{L.LedgerName}}</option>
        </datalist>

      </div>
      <span (click)="printLedgerRecord()" title="Print Statement of Accounts" style="display: inline-block; float: right;">
        <span class="btn darkBlueButton"
            style="padding: 5px 8px 4px 8px !important; margin-left: 10px;">
            <span>
                <i aria-hidden="true" class="zmdi zmdi-print" style="font-size: 16px;"></i>
            </span>
        </span>
      </span>
    </div>
  </div>

  <!-- Card Header -->
  <div class="mainCardBody" *ngIf="ledgername.length > 0">
    <div class="col-md-12 col-sm-12 col-12 pad0 mainCardItem"
      *ngFor="let v of voucher | filter:'MainLedger,user,date,VoucherNum':search; let f = first; let l = last"
      style="{{ !l ? 'border-bottom: 1px solid #ddd;' : ''}} {{ f ? 'border-top: 1px solid #ddd' : ''}}">
      <!-- <div
        *ngIf="((v.MainLedger != 'Opening Balance') || (v.MainLedger != 'Closing Balance')) && v.CloBal==0 ? null : v.isShow = !v.isShow && 'No Transactions'"> -->
        <div *ngIf="v.MainLedger" style="cursor: {{(v.MainLedger == 'Opening Balance') || (v.MainLedger == 'Closing Balance') || (v.MainLedger=='')? 'default' : 'pointer' }};">
          <div class="col-md-8 col-sm-8 col-xs-12 col-8 pad0"
            style="text-align: left; display: inline-block; {{ (v.MainLedger == 'Opening Balance') || (v.MainLedger == 'Closing Balance') ? 'color: #1F628E;' : '#333' }}"
            (click)="((v.MainLedger == 'Opening Balance') || (v.MainLedger == 'Closing Balance')) ? null : v.isShow = !v.isShow">


            <div class="budge font13 darkBlueBadgeNew brdrRadius3"style="margin: 0px;margin-right: 10px;" *ngIf="v.EffectiveDate && v.MainLedger != 'Opening Balance' && v.MainLedger != 'Closing Balance'">
              <i class="fa fa-calendar" aria-hidden="true" style="margin-right: 5px;"></i>{{v.date | todayTommorow}}
            </div>

            <div class="font13 mobView" style="margin-top: 10px;">
              <span style="font-size: 13px;">
                {{((v.MainLedger == 'Opening Balance') && (v.MainLedger == 'Closing Balance')) ? v.date
                :v.MainLedger}} </span>
            </div>

            <span class="webView" style="font-size: 13px; vertical-align: middle;">{{v.MainLedger}}</span>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12 col-4 pad0" *ngIf="v.MainLedger != ''"
            style="text-align: right; display: inline-block; {{ (v.MainLedger == 'Opening Balance') || (v.MainLedger == 'Closing Balance') ? 'color: #1F628E;' : '' }}"
            (click)="((v.MainLedger == 'Opening Balance') || (v.MainLedger == 'Closing Balance') || (v.MainLedger =='')) ? null : v.isShow = !v.isShow">
            <span style="font-size: 13px;">
              {{((v.MainLedger == 'Opening Balance') || (v.MainLedger == 'Closing Balance')) ? (v.newCloBal|cRDB) :
              (v.NewCrAmt > 0
              ? (v.NewCrAmt | lacFormat) + ' Cr' : (v.NewDbAmt | lacFormat) + ' Db')}}

            </span>
          </div>
        </div>

        <div class="col-md-12 col-sm-12 col-12 pad0" *ngIf="v.isShow" style="margin-top: 3px;">
          <!-- webview -->
          <div class="col-md-8 col-sm-8 col-8 pad0 webView" >
            <div class="row" style="margin-left: -3px;">
              <div class="budge darkBlueBadgeNew brdrRadius3"> <i class="fa fa-user" aria-hidden="true" style="margin-right: 5px;"></i> {{v.user}}
              </div>
              <div class="budge darkBlueBadgeNew brdrRadius3"style=""*ngIf="v.EffectiveDate">
                <i class="fa fa-calendar" aria-hidden="true" style="margin-right: 5px;"></i>{{v.date | todayTommorow}}
              </div>
              <div class="budge darkBlueBadgeNew brdrRadius3" style="margin-top: 5px!important;">
                {{v.VoucherNum}}
              </div>
            </div>
            <div class="row" style="margin-left: -3px;">
                <div class="budge2 btn font13 orangeButton  padLeft5 hvrInfo btnBottom" 
                  (click)="openNewWindowVoucher(v.VoucherID)" *ngIf="right.AcctsVchrEdit"            
                style="">
                <i class="fa fa-pencil" aria-hidden="true" style="margin-right: 2px;"></i> Edit
                </div>
                <div class="budge2 btn font13 orangeButton  padLeft5 hvrInfo btnBottom" *ngIf="right.AcctsVchrEdit" (click)="deleteVoucher(v.VoucherID)"
                  style="">
                  <i class="fa fa-trash" aria-hidden="true" style="margin-right: 5px;"></i>Delete
                </div>            
                <div (click)="openAttFile(v.VoucherFile)" class="budge2 btn orangeButton  padLeft5 hvrInfo btnBottom" style="padding: 3px 9px !important;"
                  *ngIf="v.VoucherFile">
                  <i class="fa fa-paperclip" aria-hidden="true"></i>
                </div>
                <div class="budge2 btn orangeButton padLeft5 hvrInfo btnBottom"
                  (click)="printVoucher(v.VoucherID,ledger.name)"
                  style="padding: 1px 7px !important;display: inline-block;">
                  <i class="zmdi zmdi-print" aria-hidden="true" style="vertical-align: sub;"></i>
                </div>
            </div>
          </div>

          <!-- mobview -->
          <div class="col-md-10 col-sm-10 col-10 pad0 mobView">
            <div class="row" style="margin: 0px;">
              <div class="budge darkBlueBadgeNew brdrRadius3"
                style="margin-left: 0px; padding: 0px 10px;">
                <i class="fa fa-user" aria-hidden="true" style="margin-right: 5px;"></i> {{v.user}}
              </div>
              <div class="budge darkBlueBadgeNew brdrRadius3"
                style="cursor: default;margin-left: 5px; padding: 0px 10px;"
                *ngIf="v.EffectiveDate">
                <i class="fa fa-calendar" aria-hidden="true" style="margin-right: 5px;"></i>{{v.date | todayTommorow}}
              </div>
              <!-- <div class="col-md-6 col-sm-6 col-4 pad0"
                style="display: inline-block; text-align: right; vertical-align: top;"> -->
              <div class="budge darkBlueBadgeNew brdrRadius3" style="margin: 5px; padding: 0px 10px;margin-left: 0px;height: 24px;
                margin-top: 5px!important;">
                {{v.VoucherNum}}
              </div>
              <!-- </div> -->
            </div>
            <div class="row" style="margin: 0px;">
              <div class="budge2 btn font13 orangeButton padLeft5 hvrInfo btnBottom" *ngIf="right.AcctsVchrEdit"
                (click)="editVoucher(mymodal,v.VoucherID)" style="margin-left: 0px; padding: 3px 10px;height: 27px;">
                <i class="fa fa-pencil" aria-hidden="true" style="margin-right: 5px;"></i> Edit
              </div>
              <div class="budge2 btn font13 orangeButton padLeft5 hvrInfo btnBottom" *ngIf="right.AcctsVchrEdit" (click)="deleteVoucher(v.VoucherID)"
                style="margin-left: 4px; padding: 3px 10px;height: 27px;">
                <i class="fa fa-trash" aria-hidden="true" style="margin-right: 5px;"></i>Delete
              </div>
              <div class="budge2 btn orangeButton padLeft5 hvrInfo btnBottom" style="padding: 3px 9px !important;"
                *ngIf="v.VoucherFile">
                <i class="fa fa-paperclip" aria-hidden="true"></i>
              </div>
              <div class="budge2 btn orangeButton padLeft5 hvrInfo btnBottom"
                (click)="printVoucher(v.VoucherID,ledger.name)"
                style="padding: 3px 9px !important;display: inline-block;">
                <i class="zmdi zmdi-print" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-6 col-sm-6 col-4 pad0"
            style="display: inline-block; text-align: right; vertical-align: top;">
            <div class="budge" style="margin: 0px; color: #daa520; border: 1px solid #daa520; padding: 0px 10px;">
              {{v.VoucherNum}} </div>
          </div> -->
        </div>
        <div class="font13" *ngIf="v.MainLedger ==''">
          No Transactions
        </div>
    </div>
  </div>
  <div class="col-md-12 col-12 col-sm-12 pad0 brdrRadius3" style="padding: 5px 10px 10px; margin-top: 0px;" *ngIf="ledgername.length == 0">
    <div class="nrf brdrRadius3" style="cursor: pointer;">Please select a ledger.</div>
  </div>
</div>


<!-- <div style="padding:15px " *ngIf="voucher.length<3">No Transactions</div> -->

<!--Expand Modal-->
<ng-template #expandModal let-modal>
  <!--Header-->
  <div class="modal-header">
    <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
      <div class="row">
        <div class="col-md-8 col-sm-10 col-10" style="padding-left: 0px;">
          <h4 class="modal-title"><span id="ApntmntHdr">Ledger Records - {{ledger.name ? ledger.name:
              ledger.LedgerName}}</span></h4>
        </div>
        <div class="col-md-4 col-sm-2 col-2" style="padding: 0px;">
          <i class="closeMdl zmdi zmdi-close" data-dismiss="modal" style="float: right;"
            (click)="modal.dismiss('Cross click')"></i>
          <span class="btn btn-yellow fntSz" (click)="exportToExcel()" title="Export to Excel"
            style="cursor:pointer;margin-right: 10px;line-height: 23px; float: right;padding:3px 9px;font-size: 12px;float: right;"><span><i
                class="fa fa-file-excel-o" aria-hidden="true"></i></span></span>
        </div>
      </div>
    </div>
  </div>
  <!--Body-->
  <div class="modal-body" style="overflow-y: auto; padding-top: 0px;">
    <table mat-table [dataSource]="dataSource" id="excel-table">
      <ng-container matColumnDef="date">
        <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px 0px 0px;">
          <label style="display:none">Date</label>
          <div class="filter" floatLabel="never">
            <input matInput class="form-control seachInput" [formControl]="DateFilter" placeholder="Date"
              style="border: none; border-bottom: 1px solid; width: 100px;">
          </div>
        </th>
        <td mat-cell *matCellDef="let person">{{person.date | todayTommorow}}</td>
      </ng-container>

      <ng-container matColumnDef="VoucherNum">
        <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px 0px 0px;">
          <label style="display:none">Voucher No.</label>
          <div class="filter" floatLabel="never">
            <input matInput class="form-control seachInput" [formControl]="VoucherNumFilter" placeholder="Voucher No."
              style="border: none; border-bottom: 1px solid;">
          </div>
        </th>
        <td mat-cell *matCellDef="let person">{{person.VoucherNum}}</td>
      </ng-container>

      <ng-container matColumnDef="MainLedger">
        <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px;">
          <label style="display: none;">Ledger</label>
          <div class="filter" floatLabel="never">
            <input matInput class="form-control seachInput" [formControl]="MainLedgerFilter" placeholder="Ledger"
              style="border: none; border-bottom: 1px solid;">
          </div>
        </th>
        <td mat-cell *matCellDef="let person" style="padding: 0px 10px !important;">{{person.MainLedger}}</td>
      </ng-container>

      <ng-container matColumnDef="DbAmt">
        <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px;">
          <label style="display: none;">Debit</label>
          <div class="filter" floatLabel="never">
            <input matInput class="form-control seachInput" [formControl]="DbAmtFilter" placeholder="Debit"
              style="border: none; border-bottom: 1px solid; width: 120px;">
          </div>
        </th>
        <td mat-cell *matCellDef="let person" style="text-align: right; padding: 0px 10px !important;">{{person.DbAmt|
          lacFormat}}</td>
      </ng-container>

      <ng-container matColumnDef="CrAmt">
        <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px;">
          <label style="display: none;">Credit</label>

          <div class="filter" floatLabel="never">
            <input matInput class="form-control seachInput" [formControl]="CrAmtFilter" placeholder="Credit"
              style="border: none; border-bottom: 1px solid; width: 120px;">
          </div>
        </th>
        <td mat-cell *matCellDef="let person" style="text-align: right; padding: 0px 10px !important;">{{person.CrAmt
          |
          lacFormat}}</td>
      </ng-container>

      <ng-container matColumnDef="CloBal">
        <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px;">
          <label style="display: none;">Closing</label>

          <div class="filter" floatLabel="never">
            <input matInput class="form-control seachInput" [formControl]="CloBalFilter" placeholder="Balance"
              style="border: none; border-bottom: 1px solid; width: 120px;">
          </div>
        </th>
        <td mat-cell *matCellDef="let person" style="text-align: right; padding: 0px 10px !important;">
          {{person.CloBal}}
        </td>
      </ng-container>

      <ng-container matColumnDef="Notes">
        <th class="header" mat-header-cell *matHeaderCellDef style="padding: 0px 10px;">
          <label style="display: none;">Notes</label>

          <div class="filter" floatLabel="never">
            <input matInput class="form-control seachInput" [formControl]="NotesFilter" placeholder="Notes"
              style="border: none; border-bottom: 1px solid;">
          </div>
        </th>
        <td mat-cell *matCellDef="let person" style="text-align: left; padding: 0px 10px !important;">{{person.Notes}}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let person; columns: displayedColumns"></tr>
    </table>
  </div>
  <!--Footer-->
  <!-- <div class="" style="padding: 15px; border: none; text-align: left; float: left;">
        <span class="btn btn-save" style="padding: 2px 10px 2px;" (click)="saveLedger()">
            <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
            <span>Save</span>
        </span>
    </div> -->
</ng-template>
